import Button from '@hud/web-components/DesignSystem/Components/Button/Button';
import { Container } from './SlackInstallationBanner.styles';
import SlackLogo from './slack-logo.svg?react';

type SlackInstallationBannerProps = {
  onInstallClick: () => void;
};

const SlackInstallationBanner: React.FC<SlackInstallationBannerProps> = ({
  onInstallClick,
}) => {
  return (
    <Container>
      <SlackLogo />
      <div className="content" aria-label="Slack connection status">
        <h3>Integrate Slack with Hud</h3>
        <p>
          To start connecting Hud notification to your Slack channels you first need to
          install Hud Slack App on your workspace.
        </p>
      </div>
      <Button onClick={onInstallClick} skin="positive" size="small">
        Connect to Slack
      </Button>
    </Container>
  );
};

export default SlackInstallationBanner;
